// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2993":"2038cda4","3259":"2038cda4"}[chunkId] + ".css";
};